import React, { useState, useEffect } from 'react'

import Grid from '@mui/material/Grid';

import RmvendorFilterCriteria from './RmvendorFilterCriteria'
import RmvendorList from './RmvendorList'
import MyPageContainer from '../../core/template/MyPageContainer';
import {getListAPI} from './RmvendorAPI';
import {transformToCardFormat} from '../../core/js/FormUtils'
import {getPathVariable} from '../../core/js/UrlUtils';

import { useSearchParams } from "react-router-dom";
import { useSelector, useDispatch } from 'react-redux';
import {setRmvendorDashboardRmvendorList } from '../../store/slice/PharmaSlice';

export default function RmvendorListView({setShowEdit,setRmvendorId}){
    const {filterCriteria} = useSelector((state)=>state.pharmaslice.rmvendorDashboard);   

    const [filteredRmvendorList, setFilteredRmvendorList] = React.useState([]);
    const [cardList, setCardList] = useState([]);
    const [searchParams, setSearchParams] = useSearchParams();
    const { showfilter } = useSelector((state) => state.confslice);
    const { rmvendorDashboard } = useSelector((state) => state.pharmaslice);
    
    function dataFetchCallBack(){
    }

    useEffect(()=>{
      if (rmvendorDashboard.rmvendorList.length>-1){
        setFilteredRmvendorList(rmvendorDashboard.rmvendorList);
        transformToCardFormat(rmvendorDashboard.rmvendorList, setCardList);
      }
    },[rmvendorDashboard.rmvendorList])

    useEffect(()=>{
          transformToCardFormat(filteredRmvendorList, setCardList);
      },[filteredRmvendorList])

    useEffect(()=>{
        if (filterCriteria.title==='' && filterCriteria.email==='' ){
            setFilteredRmvendorList(rmvendorDashboard.rmvendorList);
            transformToCardFormat(rmvendorDashboard.rmvendorList, setCardList);

        } else {
            setFilteredRmvendorList(
                rmvendorDashboard.rmvendorList
                    
                
            )
            

            //transformToCardFormat(rmvendorDashboard.filteredRmvendorList, setCardList);
        }
      },[filterCriteria])
  
     return(
        <Grid container direction="column" >
            <Grid item lg={12}>
                <RmvendorList
                    setShowEdit={setShowEdit}
                    setRmvendorId = {setRmvendorId}
                    tableList={filteredRmvendorList}
                    cardList={cardList}
                    />
          </Grid>
      </Grid>
    )
}